// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Restaumatic_Menu_Menu from "../Restaumatic.Menu.Menu/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
var filterPromotionsM$prime = function (localDateTime) {
    return function (consumers) {
        return function (promotions) {
            return Data_Map_Internal.filter(Restaumatic_Promotions_Types_Id.ordPromotionId)(Restaumatic_Menu_Promotions.isAvailableAt(localDateTime)(consumers))(promotions);
        };
    };
};
var filterPromotionsL = function (localDateTime) {
    return function (consumers) {
        return function (promotions) {
            return Data_Array.filter(Restaumatic_Menu_Promotions.isAvailableAt(localDateTime)(consumers))(promotions);
        };
    };
};
var filterPromotions = function (utcTime) {
    return function (consumers) {
        return Restaumatic_Menu_Menu.modifyMenu(function (x) {
            var localDateTime = Data_Time_Local.utcToLocalDateTime(utcTime)(x.timeZone);
            return {
                promotions: filterPromotionsM$prime(localDateTime)(consumers)(x.promotions),
                timeZone: x.timeZone,
                enableCoupons: x.enableCoupons,
                enableFod: x.enableFod,
                enableMarketingConsents: x.enableMarketingConsents,
                catalogue: x.catalogue,
                imagePrefix: x.imagePrefix
            };
        });
    };
};
export {
    filterPromotions,
    filterPromotionsL
};
//# sourceMappingURL=index.js.map
